export interface Point {
  x: number;
  y: number;
}

export const norm = ({ x, y }: Point) => {
  return Math.sqrt(x ** 2 + y ** 2);
};

export const subtract = (p1: Point, p2: Point) => {
  return {
    x: p1.x - p2.x,
    y: p1.y - p2.y,
  };
};

export const sum = (p1: Point, p2: Point) => {
  return {
    x: p1.x + p2.x,
    y: p1.y + p2.y,
  };
};

export const distance = (p1: Point, p2: Point) => {
  return norm(subtract(p1, p2));
};

export const dot = (p1: Point, p2: Point) => {
  return p1.x * p2.x + p1.y * p2.y;
};

export const degToRad = (angle: number) => {
  return (angle * Math.PI) / 180;
};

export const exp = (
  x: number,
  k: number = -1,
  a: number = 0,
  b: number = 1,
): number => {
  return a + (b - a) * Math.exp(-k * x);
};

export const identityTransform = (): number[] => {
  return [1, 0, 0, 1, 0, 0];
};
